<template>
  <div>
    <!-- Text -->
    <v-text-field
      v-show="!isTextArea"
      :variant="isLineItem ? 'solo-filled' : undefined"
      :hide-details="isLineItem ? 'auto' : ''"
      ref="textField"
      v-bind:class="{ 'pt-4': !isLineItem }"
      :disabled="documentMetadata.metadata.isReadonly"
      v-if="documentMetadata"
      v-model="localValue"
      :label="label"
      :bg-color="highlight ? 'metadataHighlight' : 'transparent'"
      :append-icon="highlight && documentMetadata.autoExtracted ? 'mdi-auto-fix' : ''"
      @focus="hasFocus = true"
      @blur="hasFocus = false"
    ></v-text-field>

    <!-- TextArea -->
    <v-textarea
      v-show="isTextArea"
      :variant="isLineItem ? 'solo-filled' : undefined"
      :rows="isLineItem ? 2 : 0"
      :auto-grow="isLineItem"
      :hide-details="isLineItem ? 'auto' : ''"
      ref="textArea"
      v-bind:class="{ 'pt-4': !isLineItem }"
      :disabled="documentMetadata.metadata.isReadonly"
      v-if="documentMetadata"
      v-model="localValue"
      :label="label"
      :bg-color="highlight ? 'metadataHighlight' : 'transparent'"
      :append-icon="highlight && documentMetadata.autoExtracted ? 'mdi-auto-fix' : ''"
      :data-cy="documentMetadata.metadata.key"
      @focus="hasFocus = true"
      @blur="hasFocus = false"
    ></v-textarea>
  </div>
</template>

<script>
import metadataType from "@/constants/metadataType";
import documentMetadataService from "@/services/documentMetadataService";
import metadataMixin from "@/mixins/metadataMixin";

export default {
  name: "TextMetadata",

  // Use the mixin to handle prop mutations properly
  mixins: [metadataMixin],

  props: {
    // documentMetadata is provided by the mixin
    textSelection: Object,
    isLineItem: Boolean,
    focusOnLoad: Boolean,
    onClickToFill: Function,
  },

  data() {
    return {
      highlight: false,
      metadataType,
      hasFocus: false,
    };
  },

  created() {
    // Use the mixin's helper method instead of direct mutation
    this.clearHighlightAfterDelay();
    documentMetadataService.focusIfRequested(this);
  },

  computed: {
    // localValue is provided by the mixin and emits events on set
    isTextArea() {
      return this.documentMetadata.metadata.metadataType.id === metadataType.TextArea;
    },
    label() {
      return this.isLineItem ? "" : this.documentMetadata.metadata.name;
    },
  },

  watch: {
    textSelection: {
      handler() {
        // Check if this field has focus using our tracked state
        if (!this.hasFocus) return;

        // Setting localValue now emits an event instead of mutating directly
        this.localValue = this.textSelection.text;

        documentMetadataService.assignTextSelection(this);

        // Show highlight effect when text is selected from PDF
        this.highlight = true;
        setTimeout(() => {
          this.highlight = false;
        }, 2000);

        if (this.onClickToFill) this.onClickToFill();
      },
      deep: true,
    },
    focusOnLoad() {
      documentMetadataService.focusIfRequested(this);
    },
  },
};
</script>
